import { MatchStatus } from '../../../enums/matchStatus';

export default function (matchStatus: number, matchLength?: string): number {
  switch (matchStatus) {
    case MatchStatus.SECOND_HALF:
      switch (matchLength) {
        case '2*40':
          return 40;
        case '2*35':
          return 35;
        case '3*30':
          return 30;
      }
      return 45;
    case MatchStatus.FIRST_HALF_EXTRA_TIME:
      switch (matchLength) {
        case '2*40':
          return 80;
        case '2*35':
          return 70;
      }
      return 90;
    case MatchStatus.SECOND_HALF_EXTRA_TIME:
      switch (matchLength) {
        case '2*40':
          return 85;
        case '2*35':
          return 75;
      }
      return 105;
    case MatchStatus.PENALTIES:
      switch (matchLength) {
        case '2*40':
          return 90;
        case '2*35':
          return 80;
      }
      return 120;
  }

  return 0;
}
